import React, { useState } from 'react'
import Menu from '../common/Menu/Menu'

import FooterThree from '../common/Footer/FooterThree';
import ElevatorLoader from '../Loder/ElevatorLoader';
import Firebanner from './Firebanner';
import FireSafetyPage from './FireSafetyPage';


const Fire = () => {
    const [loading, setLoading] = useState(true);
    
  return (
    <div>
        {loading && <ElevatorLoader onFinish={() => setLoading(false)} />}
        <Menu header_style_2={true} />
        <Firebanner/>
        <FireSafetyPage/>
        <FooterThree />

    </div>
  )
}

export default Fire